<template>
    <form-green-cmp
        v-animation:bottom.delay
        :form-info="form"
        :button="button"
        action="reviews"
        :check="true"
        class="_reviews"
    >
    </form-green-cmp>
</template>

<script>
    import formGreen from '@components/base/form-green.vue';

    export default {
        name: "form-reviews",
        props: {
            button: String
        },
        computed: {
            form() {
                return {
                    title: this.$root.staticText.reviewTitle,
                    "fields": [
                        {
                            "type": "form_field",
                            "content": {
                                "id": "name",
                                "typeField": 1,
                                "title": this.$root.staticText.forms.name,
                                "requiredField": 1,
                                "description": null,
                                "hintField": this.$root.staticText.forms.placeholderName,
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "surname",
                                "typeField": 1,
                                "title": this.$root.staticText.forms.surname,
                                "requiredField": 1,
                                "description": null,
                                "hintField": this.$root.staticText.forms.placeholderSurname,
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "socialLink",
                                "typeField": 1,
                                "title": this.$root.staticText.forms.socialLink,
                                "requiredField": 0,
                                "description": null,
                                "hintField": this.$root.staticText.forms.placeholderSocialLink,
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "company",
                                "typeField": 1,
                                "title": this.$root.staticText.forms.company,
                                "requiredField": 1,
                                "description": null,
                                "hintField": this.$root.staticText.forms.placeholderCompany,
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "city",
                                "typeField": 1,
                                "title": this.$root.staticText.forms.city,
                                "requiredField": 1,
                                "description": null,
                                "hintField": this.$root.staticText.forms.placeholderCity,
                            }
                        },

                        {
                            "type": "form_field",
                            "content": {
                                "id": "radioLike",
                                "typeField": 14,
                                "title": this.$root.staticText.forms.radioLike,
                                "requiredField": 0,
                                "description": null,
                                "hintField": null,
                                "list": [
                                    {
                                        "id": 1,
                                        "label": this.$root.staticText.forms.yes
                                    },
                                    {
                                        "id": 0,
                                        "label": this.$root.staticText.forms.no
                                    },
                                ]
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "radioPost",
                                "typeField": 14,
                                "title": this.$root.staticText.forms.radioPost,
                                "requiredField": 0,
                                "description": null,
                                "hintField": null,
                                "list": [
                                    {
                                        "id": 1,
                                        "label": this.$root.staticText.forms.yes
                                    },
                                    {
                                        "id": 0,
                                        "label": this.$root.staticText.forms.no
                                    },
                                ]
                            }
                        },

                        {
                            "type": "form_field",
                            "content": {
                                "id": "comment",
                                "typeField": 2,
                                "title": this.$root.staticText.forms.review,
                                "requiredField": 1,
                                "description": null,
                                "hintField": this.$root.staticText.forms.placeholderReview,
                            }
                        },
                    ]
                }
            }
        },
        components: {
            'form-green-cmp': formGreen,
        },
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/forms/form-reviews.vue